/*
 * SubRoleMembersCard — thin wrapper around CustomMembersListCard for sub-role
 * member lists (devLeads, qaLeads, devops) stored in a Backstage Group spec.
 */

import { Entity } from '@backstage/catalog-model';
import { InfoCardVariants } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { CustomMembersListCard } from './CustomMembersListCard';

export type SubRoleKey = 'devLeads' | 'qaLeads' | 'devops';

export interface SubRoleMembersCardProps {
  roleKey: SubRoleKey;
  title: string;
  variant?: InfoCardVariants;
}

/** Returns true when the entity has at least one member in the given sub-role. */
export const hasSubRole =
  (roleKey: SubRoleKey) =>
  (entity: Entity): boolean => {
    const members = entity.spec?.[roleKey];
    return Array.isArray(members) && (members as unknown[]).some(m => typeof m === 'string' && m.length > 0);
  };

export const SubRoleMembersCard = (props: SubRoleMembersCardProps) => {
  const { roleKey, title, variant } = props;
  const { entity } = useEntity();
  const rawRefs: unknown[] = Array.isArray(entity.spec?.[roleKey]) ? (entity.spec[roleKey] as unknown[]) : [];
  const memberRefs = rawRefs.filter((m): m is string => typeof m === 'string');
  return (
    <CustomMembersListCard title={title} memberRefs={memberRefs} variant={variant} />
  );
};
